<template>
  <span class="header-template" v-if="!single && selectionValue !== undefined" :sortable="sortable">
    <input :id="finalId" class="k-checkbox" type="checkbox" role="checkbox" :checked="selectionValue" :aria-checked="selectionValue" @change="$emit('headerselectionchange', { event: $event, field })" />
    <label :for="finalId" class="k-checkbox-label">{{ finalTitle }}</label>
  </span>
  <span v-else class="header-template" :class="{ 'k-link': sortable }" @click="doSort">
    {{ finalTitle }}
    <span v-if="isSorted" class="k-icon" :class="arrowSortedIcon"></span>
  </span>
</template>

<script>
export default {
  name: 'header-template',
  props: {
    tableId: [String, Number],
    field: String,
    title: String,
    sortable: Boolean,
    selectionValue: {
      type: Boolean,
      default: undefined
    },
    render: [String, Function, Object],
    sort: Array,
    single: {
      type: Boolean,
      default: false
    }
  },
  created () {
  },
  computed: {
    finalId: function () {
      return `k-header-checkbox-${this._uid}`  
    },
    finalTitle: function () {
      if (this.title === null || this.title === undefined) {
        if (this.field === null || this.field === undefined) {
          return ''
        }
        return this.field
      }
      return this.title
    },
    sortedByField: function () {
      const defaultSorted = { field: this.field, dir: 'none' }
      if (!this.sortable) {
        return defaultSorted
      }
      return this.sort?.find(x => x.field === this.field) ?? defaultSorted
    },
    isSorted: function () {
      return this.sortable && this.sortedByField.dir !== 'none'
    },
    isSortedAscending: function () {
      return this.isSorted && this.sortedByField.dir === 'asc'
    },
    isSortedDescending: function () {
      return this.isSorted && this.sortedByField.dir === 'desc'
    },
    arrowSortedIcon: function () {
      return {
        'k-i-sort-asc-sm': this.isSortedAscending,
        'k-i-sort-desc-sm': this.isSortedDescending
      }
    }
  },
  methods: {
    doSort: function (event) {
      if (this.sortable) {
        this.$emit('click', event)
      }
    }
  },
}
</script>

<style>

</style>
